import { createSelector } from 'reselect'

import { filterOnArticle } from '../../filters'
import { StyleboardState } from '../../types'

const getState = (state): StyleboardState => state.styleboard

const getStyleboardItems = createSelector(
  getState,
  (state) => state.styleboard?.items.filter(filterOnArticle) || [],
)
const getStyleboardItemsCount = createSelector(getStyleboardItems, (state) => state.length)

const getStyleboard = createSelector(getState, (state) => state.styleboard)
const getMyStyleboards = createSelector(getState, (state) => state.myStyleboards)
const getFollowStyleboards = createSelector(getState, (state) => state.followStyleboards)
const getPopularStyleboards = createSelector(getState, (state) => state?.popularStyleboards)
const getIsPopularStyleboardsFailed = createSelector(
  getState,
  (state) => state?.hasPopularStyleboardsLoadedFailed,
)
const getIsPopularStyleboardsLoaded = createSelector(
  getState,
  (state) => state?.hasPopularStyleboardsLoaded,
)
const getNextItemsLink = createSelector(getState, (state) => state?.styleboard?._links?.next?.href)
const getFollowStyleboardsNextItemsLink = createSelector(
  getState,
  (state) => state?.followStyleboards?._links?.next?.href,
)
const getMyStyleboardsNextItemsLink = createSelector(
  getState,
  (state) => state?.myStyleboards?._links?.next?.href,
)

const getSimilarItems = createSelector(getState, (state) => state?.styleboard?.similarItems)
const getIsSimilarItemsLoading = createSelector(getState, (state) => state.isSimilarItemsLoading)
const getIsSimilarItemsLoaded = createSelector(getState, (state) => state.hasSimilarItemsLoaded)
const getIsSimilarItemsLoadingFailed = createSelector(
  getState,
  (state) => state.hasSimilarItemsLoadingFailed,
)
const getIsAddItemToboardSucceded = createSelector(
  getState,
  (state) => state.hasAddItemToboardSucceded,
)
const getIsAddItemToboardFailed = createSelector(getState, (state) => state.hasAddItemToboardFailed)

const getIsStyleboardLoading = createSelector(getState, (state) => state.isStyleboardLoading)
const getIsMyStyleboardsLoading = createSelector(getState, (state) => state.isStyleboardsLoading)
const getIsFollowStyleboardLoaded = createSelector(
  getState,
  (state) => state.hasFollowStyleboardsLoaded,
)
const getIsFollowStyleboardLoadedFailed = createSelector(
  getState,
  (state) => state.hasFollowStyleboardsLoadedFailed,
)
const getIsFollowingStyleboardLoading = createSelector(
  getState,
  (state) => state.isFollowingStyleboardLoading,
)

const getIsFollowingStyleboardLoadingFailed = createSelector(
  getState,
  (state) => state.hasFollowingStyleboardLoadingFailed,
)

const getIsMyStyleboardLoadingFailed = createSelector(
  getState,
  (state) => state.hasStyleboardsLoadingFailed,
)

const notifications = createSelector(getState, (state) => state.notifications)

const getIsUploadingImageLoading = createSelector(
  getState,
  (state) => state.isUploadingImageLoading,
)
const gethasUploadingImageSucceded = createSelector(
  getState,
  (state) => state.hasUploadingImageSucceded,
)
const gethasUploadingImageFailed = createSelector(
  getState,
  (state) => state.hasUploadingImageFailed,
)

const getIndividualItem = createSelector(getState, (state) =>
  state.styleboard?.items.find((item) => item.id === state.individualItemId),
)

const getIsDeletionItemLoading = createSelector(getState, (state) => state.isDeletionItemLoading)

const getHasDeletedItemSucceded = createSelector(getState, (state) => state.hasDeletedItemSucceded)

const getHasDeletedItemFailed = createSelector(getState, (state) => state.hasDeletedItemFailed)

const getIsDeletingStyleboardLoading = createSelector(
  getState,
  (state) => state.isDeletingStyleboardLoading,
)

const getHasDeletedStyleboardSucceded = createSelector(
  getState,
  (state) => state.hasDeletedStyleboardSucceded,
)

const getHasDeletedStyleboardFailed = createSelector(
  getState,
  (state) => state.hasDeletedStyleboardFailed,
)

const getPublicStyleboards = createSelector(getState, (state) => state.publicStyleboards)

const getIsPublicStyleboardsLoading = createSelector(
  getState,
  (state) => state.isPublicStyleboardsLoading,
)

const getHasPublicStyleboardsLoadingFailed = createSelector(
  getState,
  (state) => state.hasPublicStyleboardsLoadingFailed,
)

const getPublicStyleboardsNextItemsLink = createSelector(
  getState,
  (state) => state.publicStyleboards?._links?.next?.href,
)

export default {
  getStyleboard,
  getMyStyleboards,
  getFollowStyleboards,
  getPopularStyleboards,
  getSimilarItems,
  getIsSimilarItemsLoading,
  getIsSimilarItemsLoaded,
  getIsSimilarItemsLoadingFailed,
  getIsAddItemToboardSucceded,
  getIsAddItemToboardFailed,
  getIsPopularStyleboardsLoaded,
  getIsFollowStyleboardLoaded,
  getIsFollowStyleboardLoadedFailed,
  getIsFollowingStyleboardLoading,
  getIsFollowingStyleboardLoadingFailed,
  getIsStyleboardLoading,
  getIsMyStyleboardsLoading,
  getIsMyStyleboardLoadingFailed,
  getStyleboardItems,
  notifications,
  getNextItemsLink,
  getFollowStyleboardsNextItemsLink,
  getMyStyleboardsNextItemsLink,
  getStyleboardItemsCount,
  getIsUploadingImageLoading,
  gethasUploadingImageSucceded,
  gethasUploadingImageFailed,
  getIndividualItem,
  getIsDeletionItemLoading,
  getHasDeletedItemSucceded,
  getHasDeletedItemFailed,
  getIsDeletingStyleboardLoading,
  getHasDeletedStyleboardSucceded,
  getHasDeletedStyleboardFailed,
  getIsPopularStyleboardsFailed,
  getPublicStyleboards,
  getIsPublicStyleboardsLoading,
  getHasPublicStyleboardsLoadingFailed,
  getPublicStyleboardsNextItemsLink,
}
